import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {DefaultDataservice} from "../../../../../../../store/core/dataservice/default.dataservice";
import {LovListModel} from "../../../api/model/lovList.model";


@Injectable()
export class LovListDataService extends DefaultDataservice<LovListModel> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig) {
        super('LovList', http, httpUrlGenerator, logger, config);
    }

}
